const jMixSummaryWorkflow = {
  props: {
    type: String,
    masterData: Array,
    data: Object,
    index: Number,
    extendClass: String,
  },

  data() {
    return {
      class: '',
      isOpenModalSummary: false,
      selectedSummary: null,
      selectedIndexSummary: null,
      defaultSummaryBlockRequester: [
        {
          key: 'draft',
          name: 'Draft',
          color: '#808285',
          type: 'first_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
        {
          key: 'sent',
          name: 'Sent',
          color: '#F36F21',
          type: 'middle_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
        {
          key: 'approved',
          name: 'Approved',
          color: '#42A5CE',
          type: 'middle_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
        {
          key: 'closed',
          name: 'Closed',
          color: '#0C9C68',
          type: 'last_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
        {
          key: 'rejected',
          name: 'Rejected',
          color: '#8A0D4F',
          type: 'block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
        {
          key: 'canceled',
          name: 'Canceled',
          color: '#4D3923',
          type: 'block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
      ],
      defaultSummaryBlockApprover: [
        {
          key: 'sent',
          name: 'Sent',
          color: '#F36F21',
          type: 'first_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        }, {
          key: 'approved_by_me',
          name: 'Approved By Me',
          color: '#42A5CE',
          type: 'middle_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        }, {
          key: 'approved',
          name: 'Approved',
          color: '#42A5CE',
          type: 'last_block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        }, {
          key: 'rejected',
          name: 'Rejected',
          color: '#8A0D4F',
          type: 'block',
          is_hidden: false,
          filter: {},
          filter_operator: '',
          filter_function: {},
        },
      ],
      lengthDefaultSummaryBlockRequester: 6,
      lengthDefaultSummaryBlockApprover: 4,
    };
  },

  methods: {
    setClassSummary(type) {
      switch (type) {
        case 'first_block':
          this.class = 'sum-start';
          break;
        case 'middle_block':
          this.class = 'sum-middle';
          break;
        case 'last_block':
          this.class = 'sum-last';
          break;
        case 'block':
          this.class = 'sum-alone-last';
          break;
        default:
          this.class = '';
          break;
      }
      return this.class;
    },

    setStyleSummary(data, color) {
      const styleColor = `--color:${color};`;
      const styleMargin = this.setStyleMargin(data);

      return `${styleColor}${styleMargin}`;
    },

    setStyleMargin(data) {
      const lastBlock = this.type === 'requestor' ? 2 : 1;
      let style = 'margin-left: 0px';
      if (this.index > 0) {
        const type = data[this.index].type;
        const blockBefore = data[this.index - 1].type;

        if (type === 'first_block') {
          if (blockBefore === 'first_block' || blockBefore === 'middle_block') {
            if ((this.index + 1) !== (data.length - lastBlock)) {
              style = 'margin-left: 27px';
            } else if ((this.index + 1) === (data.length - lastBlock)) {
              style = 'margin-left: 27px; margin-right: 33px';
            }
          } else if (blockBefore === 'last_block') {
            if ((this.index + 1) === (data.length - lastBlock)) {
              style = 'margin-right: 33px';
            }
          }
        } else if (type === 'middle_block') {
          if ((this.index + 1) === (data.length - lastBlock)) {
            style = 'margin-right: 33px';
          }
        }
      }

      return style;
    },

    isDefault(key) {
      let status = '';
      if (
        key === 'draft' || key === 'sent' ||
        key === 'approved' || key === 'approved_by_me' ||
        key === 'closed' || key === 'canceled' || key === 'rejected'
      ) {
        status = true;
      } else {
        status = false;
      }
      return status;
    },

    openModalAddBlockSummary(data, index) {
      this.isOpenModalSummary = true;
      this.selectedSummary = data;
      this.selectedIndexSummary = index;
      this.$refs.modalAddBlockSummary.show();
    },

    closeModalAddBlockSummary() {
      this.$refs.modalAddBlockSummary.hide();
      setTimeout(() => {
        this.isOpenModalSummary = false;
      }, 200);
    },

    confirmDeleteSummaryBlock(index) {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete this block?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          this.$emit('delete-block', index);
        }
      });
    },

    deleteSummaryBlock(index) {
      this.dataSetup.summary_block.splice(index, 1);
      this.setChangesValueView(true);
    },

    submitSummaryBlock(mode, data, type) {
      const indexSubmit = type === 'requestor' ? -2 : -1;
      this.setChangesValueView(true);
      if (mode === 'add') {
        this.dataSetup.summary_block.splice(indexSubmit, 0, data);
      } else {
        this.dataSetup.summary_block[this.selectedIndexSummary] = data;
      }
    },
  },
};

export default jMixSummaryWorkflow;



// WEBPACK FOOTER //
// ./src/mixins/summary/jMixSummaryWorkflow.js